<template>
  <resize-observer :breakpoints="breakpoints">
    <div id="costCalculatorResultCard" class="cost-calculator-card" slot-scope="{ el }" :class="el.is">
      <row class="header-text">
        {{$t("Header")}}
      </row>
      <row
        :class="priceProvided ? 'price-text price-text-blue' : 'price-text price-text-gray'"
      >
        <div v-if="!isLoading">{{price}}</div>
        <div v-else class="dot-flashing"></div>
      </row>
      <row class="detail-row left-column">
        <img :src="require('../assests/images/ship.svg')">
        <div class="key-text">{{$t("ShippingKey")}}</div>
        <div class="right-column bolded-text">
          {{$t("IncludedValue")}}
        </div>
      </row>
      <div class="divider"></div>
      <row class="detail-row left-column">
        <img :src="require('../assests/images/cart.svg')">
        <div class="key-text">{{$t("PickandPackKey")}}</div>
        <div class="right-column bolded-text">
          {{$t("IncludedValue")}}
          <div class="sub-right-text">{{$t("PickandPackSubValue")}}</div>
        </div>
      </row>
      <div class="divider"></div>
      <row class="detail-row left-column">
        <img :src="require('../assests/images/box.svg')">
        <div class="key-text">{{$t("PackagingKey")}}</div>
        <div class="right-column bolded-text">
          {{$t("IncludedValue")}}
        </div>
      </row>
      <div class="divider"></div>
      <row class="detail-row left-column">
        <img :src="require('../assests/images/arrow.svg')">
        <div class="key-text">{{$t("ReceivingKey")}}</div>
        <div :class="el.is.sm ? 'right-column inline-min-content' : 'right-column'">
          {{$t("ReceivingValue")}}
        </div>
      </row>
      <div class="divider"></div>
      <row class="detail-row left-column">
          <img :src="require('../assests/images/home.svg')">
          <div class="key-text">{{$t("StorageKey")}}</div>
        <div class="right-column">
            <div>{{$t("StorageValue1")}}</div>
            <div>{{$t("StorageValue2")}}</div>
            <div>{{$t("StorageValue3")}}</div>
        </div>
      </row>
      <row class="footer-text">
        {{$t("Footer")}}
      </row>
    </div>
  </resize-observer>
</template>

<script>
export default {
  components: {
  },
  props: {
    resultValue: {
      type: String
    },
    isLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      breakpoints: {
        sm: el => el.width < 640,
        lg: el => el.width >= 640 && el.width < 920,
        xl: el => el.width >= 920
      }
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
    priceProvided () {
      return !!this.resultValue
    },
    price () {
      const pricingValues = this.resultValue && this.resultValue.split(',')
      switch (pricingValues && pricingValues.length) {
        case 2:
          return `$${pricingValues[0]}-$${pricingValues[1]}`
        case 1:
          return `$${pricingValues[0]}`
        default:
          return '$-'
      }
    }
  },
  methods: {
  },
  watch: {
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'Your average estimated total fulfillment cost to ship one order in the US is',
        ShippingKey: 'Shipping',
        PickandPackKey: 'Pick and pack',
        PackagingKey: 'Standard packaging',
        ReceivingKey: 'Receiving inventory',
        StorageKey: 'Storage',
        IncludedValue: 'Included above',
        PickandPackSubValue: 'for first 4 picks',
        ReceivingValue: '+$25 for first two hours',
        StorageValue1: '+$40 per pallet/month',
        StorageValue2: '$10 per shelf/month',
        StorageValue3: '$5 per bin/month',
        Footer: 'Costs can vary based on the fulfillment center location and shipping destination, as well as other value-added service (e.g., B2B fulfillment, kitting, and more).'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../onboarding.scss';
@import './CostCalculatorResultCart.scss';
</style>